import type { SVGProps } from 'react';
const SvgAlertBell = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
    <desc>{'Alert Bell Notification 2 Streamline Icon: https://streamlinehq.com'}</desc>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.875 5.827a3 3 0 1 0 6 0 3 3 0 1 0-6 0M9.125 21.75a2.087 2.087 0 0 0 4.005 0M11.125 3V.75M18.648 11.961c.189 5.756 1.477 6.789 1.477 6.789h-18s1.5-1.916 1.5-8.25a7.507 7.507 0 0 1 9.724-7.165"
    />
  </svg>
);
export default SvgAlertBell;
